import {Component, OnInit} from '@angular/core';
import {ConversionsReferenceDataService} from '../../services/conversions-reference-data.service';
import {DocumentSession} from '../../model/DocumentSession';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {SelectedSessionDetails} from '../../model/SelectedSessionDetails';

@Component({
    selector: 're-resident-doc-move',
    templateUrl: './resident-doc-move.component.html',
    styleUrls: ['./resident-doc-move.component.scss'],
    standalone: false
})
export class ResidentDocMoveComponent implements OnInit {
   static readonly documentSessionDetails = 'documentSessionDetails';
   static readonly sessionIdKey = 'sessionKey';
   todaysDate: Date;
  _sessionsArray: Array<any> = [];

  constructor(private conversionsReferenceDataService: ConversionsReferenceDataService,    private router: Router, private selectedSessionDetails: SelectedSessionDetails) { }

  ngOnInit() {
    this.todaysDate = new Date();

    this.conversionsReferenceDataService.getResidentDocumentSessions().subscribe((data: any) => {
      Object.keys(data).forEach(key => {
        const documentSessionObject: DocumentSession  = <DocumentSession>JSON.parse(data[key]);
        this._sessionsArray.push({k: key, m: documentSessionObject});
      });
    });
  }



  routeToDetailsPage(key: string, documentSession: DocumentSession) {
    sessionStorage.setItem(ResidentDocMoveComponent.sessionIdKey, key);
    sessionStorage.setItem(ResidentDocMoveComponent.documentSessionDetails, JSON.stringify(documentSession));
    this.router.navigate(['/conversions/resident-doc-move/detail']);
  }

  }




